export default __webpack_public_path__ + "static/media/LMNTLair2-icon.f0e919ff.png";